const normalizeLanguage = (language) => (language ? language.toUpperCase() : 'EN');

const normalizePermissionEntry = (permissionTranslations) => {
  if (!permissionTranslations || typeof permissionTranslations !== 'object') {
    return { name: {}, description: {} };
  }

  if (permissionTranslations.name || permissionTranslations.description) {
    return {
      name: permissionTranslations.name || {},
      description: permissionTranslations.description || {},
    };
  }

  return {
    name: permissionTranslations,
    description: {},
  };
};

const getLocalizedValue = (translations, language) => {
  const normalizedLanguage = normalizeLanguage(language);

  if (translations[normalizedLanguage]) {
    return translations[normalizedLanguage];
  }

  if (translations.EN) return translations.EN;
  if (translations.PT) return translations.PT;
  if (translations.ES) return translations.ES;

  const values = Object.values(translations);
  return values.length > 0 ? values[0] : '';
};

export const getPermissionName = (permissionTranslations, language) => {
  const { name } = normalizePermissionEntry(permissionTranslations);
  return getLocalizedValue(name, language);
};

export const getPermissionDescription = (permissionTranslations, language) => {
  const { description } = normalizePermissionEntry(permissionTranslations);
  return getLocalizedValue(description, language);
};

export const PERMISSION_CATEGORY_ORDER = [
  'teamMembers',
  'stores',
  'services',
  'appointments',
  'memberships',
  'servicePackages',
  'customers',
  'products',
  'stock',
  'expenses',
  'employeePayments',
  'chat',
  'other',
];

export const getPermissionCategory = (permission) => {
  if (!permission) {
    return 'other';
  }

  if (permission.startsWith('team-members')) return 'teamMembers';
  if (permission.startsWith('stores')) return 'stores';
  if (permission.startsWith('services')) return 'services';
  if (permission.startsWith('appointments')) return 'appointments';
  if (permission.startsWith('memberships')) return 'memberships';
  if (permission.startsWith('service-packages')) return 'servicePackages';
  if (permission.startsWith('customers')) return 'customers';
  if (permission.startsWith('products') || permission.startsWith('product-sales')) return 'products';
  if (permission.startsWith('stock') || permission.startsWith('suppliers')) return 'stock';
  if (permission.startsWith('expenses')) return 'expenses';
  if (permission.startsWith('employee-payments')) return 'employeePayments';
  if (permission === 'chat' || permission.startsWith('chat.')) return 'chat';
  return 'other';
};

export const groupPermissionsByCategory = (permissions) => (
  (permissions || []).reduce((grouped, permission) => {
    const category = getPermissionCategory(permission);
    if (!grouped[category]) {
      grouped[category] = [];
    }
    grouped[category].push(permission);
    return grouped;
  }, {})
);

export const orderedPermissionCategoryEntries = (grouped) => (
  PERMISSION_CATEGORY_ORDER
    .filter((category) => grouped?.[category]?.length)
    .map((category) => [category, grouped[category]])
);
